import { Trans, useTranslation } from 'react-i18next';
import { Image, Text, View } from '@react-pdf/renderer';

import PageLayout from 'components/pages/businessCase/reports/components/pdfReport/layout/pageLayout/pageLayout';
import { IPdfReports } from 'components/pages/businessCase/reports/components/pdfReport/types';

import styles from '../styles';
import { TOptionsBase } from 'i18next';

interface IProps {
  evICEComparisonBarChartUrl?: string;
  pdfReport: IPdfReports;
}
const DetailedCostComparison = ({ evICEComparisonBarChartUrl, pdfReport }: IProps) => {
  const { t } = useTranslation('report');

  const T = (key: string, option?: TOptionsBase & object & { months: number }) =>
    t(`detailedCost.${key}`, option!);
  return (
    <PageLayout>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>{T('headerTitle')}</Text>
        <Text style={styles.headerSubtitle}>{T('headerSubtitle')}</Text>
      </View>
      <View>
        <Text style={styles.totalCostDesc}>
          <Text style={styles.totalCostTitle}>
            {T('disclaimerTitle', { months: pdfReport?.tcoBreakevenPoint })}
          </Text>
          <Trans
            i18nKey="detailedCost.disclaimerSubtitle"
            t={t}
            values={{ percent: pdfReport?.evTcoInfraCostPercentage }}
          >
            one
            <Text style={styles.bold}>two</Text>
          </Trans>
          {/*{T('disclaimerSubtitle', { percent: pdfReport?.evTcoInfraCostPercentage })}*/}
        </Text>
      </View>
      <View style={styles.barChartWrapper}>
        <Image src={evICEComparisonBarChartUrl} />
      </View>
    </PageLayout>
  );
};
export default DetailedCostComparison;
